export default __webpack_public_path__ + "static/media/keyboard.3b041530.svg";